import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
  textFieldCell: {
    display: 'flex',
    minWidth: 100,
  },
});

const TextFieldCell = ({ row, column: { accessor: key } }) => {
  const classes = useStyles();

  const { Id, editRow } = row;

  const currentValue = row[key];

  const [value, setValue] = useState(currentValue);

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    editRow({ id: Id, key, value });
  };

  return (
    <div className={classes.textFieldCell} key={key}>
      <TextField
        fullWidth
        size="small"
        value={value || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        inputProps={{
          'aria-label': 'Input Field',
        }}
      />
    </div>
  );
};

export default TextFieldCell;
